function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-119b32c0\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader?{\"globalVars\":{\"museUiTheme\":\"'/usr/src/app/node_modules/muse-ui/src/styles/themes/variables/default.less'\"}}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SleepWearable.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SleepWearable.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-119b32c0\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SleepWearable.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-119b32c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Tracking/SleepWearable.vue
// module id = 3574
// module chunks = 1